/* eslint-disable no-unused-vars, no-undef */
window.Tentbox = window.Tentbox || {}
window.Tentbox.canPlayVideo = true

function getFocusableElements (container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  )
}

function determineBandwidth () {
  let downlink
  try {
    downlink = navigator.connection.downlink
  } catch (e) {
    console.log(`Unable to determine downlink - `, e)
  }

  // only override values if they differ
  if (downlink && downlink >= 1) {
    return
  }
  if (!downlink) return
  window.Tentbox.canPlayVideo = false
  console.log(`Not showing video due to low bandwidth`)
}

determineBandwidth()

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button')
  summary.setAttribute(
    'aria-expanded',
    summary.parentNode.hasAttribute('open'),
  )

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id)
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open'),
    )
  })

  if (summary.closest('header-drawer')) return
  summary.parentElement.addEventListener('keyup', onKeyUpEscape)
})

const trapFocusHandlers = {}

function trapFocus (container, elementToFocus = container) {
  const elements = getFocusableElements(container)
  const first = elements[0]
  const last = elements[elements.length - 1]

  removeTrapFocus()

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    ) {
      return
    }

    document.addEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener('focusout', trapFocusHandlers.focusout)
  document.addEventListener('focusin', trapFocusHandlers.focusin)

  elementToFocus.focus()
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible')
} catch (e) {
  focusVisiblePolyfill()
}

function focusVisiblePolyfill () {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ]
  let currentFocusedElement = null
  let mouseClick = null

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false
    }
  })

  window.addEventListener('mousedown', (event) => {
    mouseClick = true
  })

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) {
        currentFocusedElement.classList.remove('focused')
      }

      if (mouseClick) return

      currentFocusedElement = document.activeElement
      currentFocusedElement.classList.add('focused')
    },
    true,
  )
}

function pauseAllMedia () {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*',
    )
  })
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*')
  })
}

function removeTrapFocus (elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin)
  document.removeEventListener('focusout', trapFocusHandlers.focusout)
  document.removeEventListener('keydown', trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

function onKeyUpEscape (event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return

  const openDetailsElement = event.target.closest('details[open]')
  if (!openDetailsElement) return

  const summaryElement = openDetailsElement.querySelector('summary')
  openDetailsElement.removeAttribute('open')
  summaryElement.setAttribute('aria-expanded', false)
  summaryElement.focus()
}

class QuantityInput extends HTMLElement {
  constructor () {
    super()
    this.input = this.querySelector('input')
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this)),
    )
  }

  onButtonClick (event) {
    event.preventDefault()
    const previousValue = this.input.value

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent)
    }
  }
}

customElements.define('quantity-input', QuantityInput)

function debounce (fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

function fetchConfig (type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  }
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify === 'undefined') {
  window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments)
  }
}

Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i]
    if (value === option.value || value === option.innerHTML) {
      selector.selectedIndex = i
      return i
    }
  }
}

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent(`on${eventName}`, callback)
}

Shopify.postLink = function (path, options) {
  options = options || {}
  const method = options.method || 'post'
  const params = options.parameters || {}

  const form = document.createElement('form')
  form.setAttribute('method', method)
  form.setAttribute('action', path)

  for (const key in params) {
    const hiddenField = document.createElement('input')
    hiddenField.setAttribute('type', 'hidden')
    hiddenField.setAttribute('name', key)
    hiddenField.setAttribute('value', params[key])
    form.appendChild(hiddenField)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid)
  this.provinceEl = document.getElementById(province_domid)
  this.provinceContainer = document.getElementById(
    options.hideElement || province_domid,
  )

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this),
  )

  this.initCountry()
  this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
  initCountry () {
    const value = this.countryEl.getAttribute('data-default')
    Shopify.setSelectorByValue(this.countryEl, value)
    this.countryHandler()
  },

  initProvince () {
    const value = this.provinceEl.getAttribute('data-default')
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value)
    }
  },

  countryHandler (e) {
    let opt = this.countryEl.options[this.countryEl.selectedIndex]
    const raw = opt.getAttribute('data-provinces')
    const provinces = JSON.parse(raw)

    this.clearOptions(this.provinceEl)
    if (provinces && provinces.length === 0) {
      this.provinceContainer.style.display = 'none'
    } else {
      for (let i = 0; i < provinces.length; i++) {
        opt = document.createElement('option')
        opt.value = provinces[i][0]
        opt.innerHTML = provinces[i][1]
        this.provinceEl.appendChild(opt)
      }

      this.provinceContainer.style.display = ''
    }
  },

  clearOptions (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  },

  setOptions (selector, values) {
    for (let i = 0, count = values.length; i < values.length; i++) {
      const opt = document.createElement('option')
      opt.value = values[i]
      opt.innerHTML = values[i]
      selector.appendChild(opt)
    }
  },
}

class DeferredMedia extends HTMLElement {
  constructor () {
    super()
    const poster = this.querySelector('[id^="Deferred-Poster-"]')
    if (!poster) return
    poster.addEventListener('click', this.loadContent.bind(this))
  }

  loadContent (focus = true) {
    window.pauseAllMedia()
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div')
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true),
      )

      this.setAttribute('loaded', true)
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe'),
      )
      if (focus) deferredElement.focus()
    }
  }
}

customElements.define('deferred-media', DeferredMedia)
// ------> TENTBOX

// Obscures

const bodyObscure = document.querySelector('#tb_body_obscure')
const pageObscure = document.querySelector('#tb_page_obscure')

function showBodyObscure (show) {
  if (show) {
    bodyObscure.classList.remove('invisible', 'opacity-0')
  } else {
    bodyObscure.classList.add('invisible', 'opacity-0')
  }
}

window.addEventListener('show:body-obscure', () => {
  showBodyObscure(true)
})

window.addEventListener('hide:body-obscure', () => {
  showBodyObscure(false)
})

window.addEventListener('toggle:body-obscure', (e) => {
  showBodyObscure(e.detail)
})

function showPageObscure (show) {
  const isShowing = !pageObscure.classList.contains('invisible')
  if (isShowing === show) return

  if (show) {
    pageObscure.classList.remove('invisible', 'opacity-0')
    showBodyObscure(false)
    window.dispatchEvent(new CustomEvent('hide:mobile-menu'))
    return
  }

  pageObscure.classList.add('invisible', 'opacity-0')
}

window.addEventListener('show:page-obscure', () => {
  showPageObscure(true)
})

window.addEventListener('hide:page-obscure', () => {
  showPageObscure(false)
})

window.addEventListener('toggle:page-obscure', (e) => {
  showPageObscure(e.detail)
})

function allowPageScroll (scroll) {
  if (scroll === false) {
    document.body.classList.add('tb-overflow-hidden')
  } else if (scroll === true) {
    document.body.classList.remove('tb-overflow-hidden')
  }
}

window.addEventListener('allow:page-scroll', () => {
  allowPageScroll(true)
})

window.addEventListener('prevent:page-scroll', () => {
  allowPageScroll(false)
})

window.addEventListener('toggle:page-scroll', (e) => {
  allowPageScroll(e.detail)
})

bodyObscure.addEventListener('click', () => {
  showBodyObscure(false)
  allowPageScroll(true)
  window.dispatchEvent(new CustomEvent('hide:mobile-menu'))
  window.dispatchEvent(new CustomEvent('hide:search-modal'))
})

function extractCurrencySymbol (priceString) {
  // Extracts the first non-numeric character (assuming this is the currency symbol)
  const match = priceString.match(/[^\d.,\s]/)
  return match ? match[0] : ''
}

function parsePrice (priceString) {
  const numberString = priceString.replace(/[^\d.,-]/g, '')
  const separator = numberString.includes(',') && numberString.indexOf(',') > numberString.indexOf('.') ? ',' : '.'
  const parts = numberString.split(separator)
  const integerPart = parts[0].replace(/[^\d-]/g, '')
  const decimalPart = parts[1] || '00'
  return parseFloat(`${integerPart}.${decimalPart}`)
}

function formatPrice (amount) {
  const separator = this.priceText.includes(',') ? ',' : '.'
  const formattedPrice = amount.toFixed(2).replace('.', separator)
  return `${this.currencySymbol}${formattedPrice}`
}

function dispatchVariantAddEvent (variant, numberOfCheckedInputs) {
  const event = new CustomEvent('crosssell:variant-add', {
    detail: {
      multipleChecked: numberOfCheckedInputs > 1,
      numberOfCheckedInputs,
      variant: variant.id,
      parentId: variant.parentId,
      price: Number(variant.price * 100),
      adjustPrice: Number(variant.adjustedPrice * 100),
    },
  })
  window.dispatchEvent(event)
}

function dispatchVariantRemoveEvent (variant, numberOfCheckedInputs) {
  const event = new CustomEvent('crosssell:variant-remove', {
    detail: {
      multipleChecked: numberOfCheckedInputs > 1,
      numberOfCheckedInputs,
      variant: variant.id,
      parentId: variant.parentId,
      price: Number(variant.price * 100),
      adjustPrice: Number(variant.adjustedPrice * 100),
    },
  })
  window.dispatchEvent(event)
}

function handleVariantButtonClick (event, data) {
  const variant = event.target

  const input = variant.querySelector('input')
  if (!variant) return
  const checked = variant.getAttribute('checked') === 'true'
  variant.setAttribute('checked', !checked)
  input.checked = !checked

  const numberOfCheckedInputs = variant.parentElement.querySelectorAll('input:checked').length

  checked ? dispatchVariantRemoveEvent(data, numberOfCheckedInputs) : dispatchVariantAddEvent(data, numberOfCheckedInputs)
}

function dispatchCloseModalEvent () {
  const event = new CustomEvent('close:modal')
  window.dispatchEvent(event)
}

const scriptsLoading = {}

function loadScript (src, callback, isModule = false) {
  // If script is currently loading, queue the callback
  if (scriptsLoading[src]) {
    scriptsLoading[src].push(callback)
    return
  }

  // If script is already loaded, execute the callback immediately
  if (document.querySelector(`script[src="${src}"]`) && !scriptsLoading[src]) {
    callback && callback()
    return
  }

  // Mark the script as loading and initialize the callback queue
  scriptsLoading[src] = [callback]

  // Create and append the script element
  const script = document.createElement('script')
  script.src = src
  isModule ? script.type = 'module' : script.type = 'text/javascript'
  script.onload = () => {
    // Execute all queued callbacks
    scriptsLoading[src].forEach(cb => cb && cb())
    // Clean up
    delete scriptsLoading[src]
  }
  script.onerror = () => {
    // Handle load errors
    console.error(`Failed to load script: ${src}`)
    scriptsLoading[src].forEach(cb => cb && cb(new Error(`Failed to load script: ${src}`)))
    delete scriptsLoading[src]
  }
  document.head.appendChild(script)
}

class CopyToClipboard extends HTMLElement {
  connectedCallback () {
    this.addEventListener('click', this.copy.bind(this))
  }

  copy () {
    const valueToCopy = this.value
    if (!valueToCopy) return

    const textarea = document.createElement('textarea')
    textarea.value = valueToCopy
    document.body.appendChild(textarea)
    textarea.select()
    try {
      document.execCommand('copy')
      this.showCompletedIcon()
    } catch (err) {
      console.error('Failed to copy text', err)
    }
    document.body.removeChild(textarea)
  }

  showCompletedIcon () {
    const iconSVG = this.completedIcon.querySelector('svg')
    this.completedIcon.classList.remove('hidden')
    requestAnimationFrame(() => {
      this.completedIcon.classList.add('flex')
      this.completedIcon.classList.add('opacity-100')
      this.classList.add('pointer-events-none')
      iconSVG.classList.add('tb-animate-scale-up')
      setTimeout(() => {
        this.completedIcon.classList.remove('opacity-100')
        setTimeout(() => {
          iconSVG.classList.remove('tb-animate-scale-up')
          this.classList.remove('pointer-events-none')
          this.completedIcon.classList.remove('flex')
          this.completedIcon.classList.add('hidden')
        }, 250)
      }, 3000)
    })
  }

  get value () {
    return this.dataset.value
  }

  get message () {
    return this.dataset.message || 'Copied to clipboard'
  }

  get completedIcon () {
    return this.querySelector('.copy-to-clipboard__completed')
  }
}

if (!customElements.get('copy-to-clipboard')) {
  customElements.define('copy-to-clipboard', CopyToClipboard)
}

class NotificationsComponent extends HTMLElement {
  connectedCallback () {
    this.notificationDuration = 3000
    this.fadeTransitionDuration = 220

    // Create a container for notifications if it doesn't exist
    if (!this.querySelector('.notifications-container')) {
      const container = document.createElement('div')
      container.classList.add('notifications-container', 'fixed', 'bottom-2', 'left-1/2', 'transform', '-translate-x-1/2', 'space-y-2', 'z-max', 'pointer-events-none')
      this.appendChild(container)
    }

    this.container = this.querySelector('.notifications-container')
    window.addEventListener('show:notification', this.showNotification.bind(this))
  }

  showNotification (event) {
    const notificationContent = event.detail

    // Create a new notification element
    const notification = document.createElement('div')
    notification.classList.add(
      'flex', 'items-center', 'justify-center', 'w-fit', 'py-3', 'px-4',
      'text-white', 'text-sm', 'font-semibold', 'bg-whatsapp', 'opacity-0',
      'translate-y-4', 'transition-opacity', 'duration-200', 'transform', 'rounded-lg',
    )
    notification.textContent = notificationContent

    // Append the notification to the container
    this.container.appendChild(notification)

    // Force reflow to trigger CSS transitions
    requestAnimationFrame(() => {
      notification.classList.remove('opacity-0', 'translate-y-4')
      notification.classList.add('opacity-100', 'translate-y-0')
    })

    // Remove notification after the specified duration
    setTimeout(() => {
      this.hideNotification(notification)
    }, this.notificationDuration)
  }

  hideNotification (notification) {
    // Fade out the notification
    notification.classList.remove('opacity-100', 'translate-y-0')
    notification.classList.add('opacity-0', 'translate-y-4')

    // Remove the notification from the DOM after the fade-out transition
    setTimeout(() => {
      notification.remove()
    }, this.fadeTransitionDuration)
  }
}

if (!customElements.get('notifications-component')) {
  customElements.define('notifications-component', NotificationsComponent)
}

class ShareButton extends HTMLElement {
  constructor () {
    super()
    this.shareUrl = this.dataset.shareUrl || ''
    this.button = this.querySelector('.button')
  }

  connectedCallback () {
    this.button.addEventListener('click', this.share.bind(this))
  }

  async share (e) {
    e.preventDefault()

    // Check if running on mobile and has share API support
    if (navigator.share && /Mobi|Android/i.test(navigator.userAgent)) {
      try {
        await navigator.share({
          url: this.shareUrl,
        })
        // Don't show popover after successful native share
      } catch (err) {
        // Only fallback to clipboard copy if share fails (not when cancelled)
        if (err.name !== 'AbortError') {
          this.copyToClipboard()
        }
      }
    } else {
      // Desktop functionality
      this.copyToClipboard()
    }
  }

  copyToClipboard () {
    const textarea = document.createElement('textarea')
    textarea.value = this.shareUrl
    document.body.appendChild(textarea)
    textarea.select()

    try {
      document.execCommand('copy')
      this.showPopover()
    } catch (err) {
      console.error('Failed to copy URL', err)
    }

    document.body.removeChild(textarea)
  }

  showPopover () {
    // Remove existing popover if present
    const existingPopover = this.querySelector('.share-popover')
    if (existingPopover) existingPopover.remove()

    // Create and add popover
    const popover = document.createElement('div')
    popover.classList.add(
      'share-popover',
      'absolute',
      'top-full',
      'right-0',
      'mt-2',
      'px-3',
      'py-2',
      'bg-white',
      'text-black',
      'border',
      'border-steel',
      'shadow-lg',
      'text-sm',
      'rounded',
      'opacity-0',
      'transition-opacity',
      'whitespace-nowrap',
      'z-[99999]',
    )

    // Create tail element as span with hidden text
    const tail = document.createElement('span')
    tail.classList.add(
      'absolute',
      '-top-2',
      'right-6',
      'w-3',
      'h-4',
      'rotate-45',
      'border-l',
      'border-t',
      'border-steel',
      'bg-white',
    )
    const srText = document.createElement('span')
    srText.classList.add('sr-only')
    srText.textContent = 'Popover tail'
    tail.appendChild(srText)

    popover.textContent = window.Tentbox.translations.url_copied || 'URL copied to clipboard'
    popover.appendChild(tail)

    this.appendChild(popover)

    // Trigger animation
    requestAnimationFrame(() => {
      popover.classList.add('opacity-100')

      // Remove popover after delay
      setTimeout(() => {
        popover.classList.remove('opacity-100')
        setTimeout(() => popover.remove(), 200)
      }, 2000)
    })
  }
}

if (!customElements.get('share-button')) {
  customElements.define('share-button', ShareButton)
}

window.Tentbox.loadScript = loadScript

// Observe body child nodes to check if '.kl_reviews__lightbox_background' is added/present. The element gets destroyed when closed so needs to not disconnect the observer.
const bodyObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.classList && node.classList.contains('kl_reviews__lightbox_background')) {
        const klaviyoBackdrop = document.querySelector('.kl_reviews__lightbox_background')
        if (klaviyoBackdrop) {
          klaviyoBackdrop.addEventListener('click', (e) => {
            const target = e.target
            if (target !== klaviyoBackdrop) return
            const klaviyoCloseButton = document.querySelector('.kl_reviews__close_button')
            if (klaviyoCloseButton) {
              klaviyoCloseButton.click()
            }
          })
        }
      }
    })
  })
})

bodyObserver.observe(document.body, { childList: true })

// Tracking: may be used if GTM is not working

// const trackedElements = new Set()

// function handleTrackingClick (event) {
//   const element = event.currentTarget
//   const trackingId = element.getAttribute('data-tracking')
//   if (!trackingId) return

//   try {
//     if (typeof gtag !== 'undefined') {
//       gtag('event', 'click', {
//         eventCategory: 'User Interaction',
//         eventLabel: trackingId,
//         value: 1,
//       })
//     }
//   } catch (error) {
//     console.error('Error tracking event:', error)
//   }
// }

// function addTrackingElement (element) {
//   if (element.hasAttribute('data-tracking')) {
//     trackedElements.add(element)
//   }
// }

// function removeTrackingElement (element) {
//   trackedElements.delete(element)
// }

// // Only handle clicks on tracked elements
// document.addEventListener('click', (event) => {
//   if (trackedElements.has(event.target)) {
//     handleTrackingClick(event)
//   }
// })

// // Watch for new elements with tracking
// const trackingObserver = new MutationObserver((mutations) => {
//   mutations.forEach((mutation) => {
//     mutation.addedNodes.forEach((node) => {
//       if (node.nodeType === Node.ELEMENT_NODE) {
//         addTrackingElement(node)
//         // Check children too
//         node.querySelectorAll('[data-tracking]').forEach(addTrackingElement)
//       }
//     })
//     mutation.removedNodes.forEach((node) => {
//       if (node.nodeType === Node.ELEMENT_NODE) {
//         removeTrackingElement(node)
//         // Remove children too
//         node.querySelectorAll('[data-tracking]').forEach(removeTrackingElement)
//       }
//     })
//   })
// })

// // Start observing the document for changes
// trackingObserver.observe(document.body, {
//   childList: true,
//   subtree: true,
// })

// // Add existing tracked elements
// document.querySelectorAll('[data-tracking]').forEach(addTrackingElement)
